import { DatePicker, TimePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { DateTime } from 'luxon';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';

export interface CancellationPracticeVM {
  suspensionDate?: DateTime | null;
  time?: DateTime | null;
  reason?: string;
}

interface AccordionCancellationPracticeFormProps {
  disabled?: boolean;
  values?: CancellationPracticeVM;
  errors?: FormikErrors<CancellationPracticeVM>;
  touched?: FormikTouched<CancellationPracticeVM>;
  onChange: (
    key: keyof CancellationPracticeVM,
    value: CancellationPracticeVM[keyof CancellationPracticeVM]
  ) => void;
}

const AccordionCancellationPracticeFormComponent = ({
  disabled,
  values,
  onChange,
  touched,
  errors,
}: AccordionCancellationPracticeFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <DatePicker
          label="Data sospensione *"
          aria-label="Data sospensione"
          value={values?.suspensionDate || null}
          onChange={(date) => onChange('suspensionDate', date)}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="suspensionDate"
              fullWidth
              error={touched?.suspensionDate && Boolean(errors?.suspensionDate)}
              helperText={errors?.suspensionDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TimePicker
          label="Ora *"
          value={values?.time || null}
          onChange={(date) => {
            onChange('time', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              id="time"
              {...params}
              fullWidth
              error={touched?.time && Boolean(errors?.time)}
              helperText={errors?.time}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          id="reason"
          label="Motivo *"
          aria-label="motivo"
          fullWidth
          multiline
          rows={5}
          inputProps={{
            maxLength: '100',
          }}
          onChange={(event) => {
            onChange('reason', event.target.value);
          }}
          value={values?.reason || ''}
          error={touched?.reason && Boolean(errors?.reason)}
          helperText={errors?.reason}
        />
      </Grid>
    </Grid>
  );
};

AccordionCancellationPracticeFormComponent.displayName = 'Accordion end practice form component';

const AccordionCancellationPracticeForm = memo(AccordionCancellationPracticeFormComponent);

export default AccordionCancellationPracticeForm;
